import { Grid } from "@material-ui/core";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { Button, Input, SelectBox, Text } from "sunrise-ui";
import ErrorText from "../../components/helperComponents/ErrorText";
import TableComponent from "../../components/tableComponents/TableComponent";
import TableHeading from "../../components/tableComponents/TableHeadings";
import { DATA_NOT_FOUND } from "../../constants/globalConstants";
import {
  manageThreshold,
  tableTitle,
} from "../../constants/inventoryTableHeadings";
import {
  ERROR_ITEMNAME,
  ERROR_PROJECTNAME,
  ERROR_STD_CONSUMPTION_PER_MT,
  ERROR_THRESHOLD,
  ERROR_UNIT,
} from "../../constants/validationMessages";
import {
  getAllProjectData,
  getItemTypeData,
  getUnitTypeData,
} from "../../redux/reducers/projectReducers";
import {
  createThreholdValue,
  getThresholdData,
  // setThresholdHistory,
  updateThreholdValue,
} from "../../redux/reducers/thresholdItems";
import { AppDispatch } from "../../redux/store";
import Loader from "../../utilities/Loader";
import NoDataScreen from "../../utilities/NoDataScreen";
import toaster from "../../utilities/toaster";

const ThresholdValues = () => {
  const dispatch = useDispatch<AppDispatch>();

  // -----------loader state------------
  let [loading, setLoading] = useState(false);
  let [loadingBtn, setLoadingBtn] = useState(false);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    setLoading(true);
    dispatch(getAllProjectData({ endPoint: "project/get-all-projects" }));
    dispatch(
      getItemTypeData({ endPoint: "master-data/get-master-data?type=items" })
    );
    dispatch(
      getUnitTypeData({
        endPoint: "master-data/get-master-data?type=unit",
      })
    );
    dispatch(
      getThresholdData({
        endPoint: `threshold-info/get-all-threshold-info/`,
      })
    ).then((res) => {
      setLoading(false);
    });
  }, [dispatch]);
  // setDelete
  const [deleted, setDeleted] = useState(false);

  const thresholdValues = useSelector(
    (state: any) => state.THRESHOLD_VALUES.thresholdData
  );
  // const createdData = useSelector(
  //   (state: any) => state.THRESHOLD_VALUES.createdData
  // );
  useEffect(() => {
    if (deleted) {
      dispatch(
        getThresholdData({
          endPoint: `threshold-info/get-all-threshold-info/`,
        })
      );
    }
    setDeleted(false);
  }, [dispatch, deleted]);

  //set project id
  const [projectId, setProjectId] = useState("");

  const unitTypes = useSelector((state: any) => state.PROJECT.unitTypeData);
  const itemTypes = useSelector((state: any) => state.PROJECT.itemTypeData);

  const allProjectData = useSelector(
    (state: any) => state.PROJECT.allProjectData
  );
  const projectsData: [] =
    allProjectData &&
    allProjectData?.map((item: any) => {
      return item?.projectName;
    });

  // add threshold values data
  const [rowData, setRowData] = useState<any>({});

  // add threshold values data
  const [projectName, setProjectName] = useState<any>("");
  const [itemName, setItemName] = useState("");
  const [thresholdValue, setThresholdValue] = useState("");
  const [unit, setUnit] = useState("");
  const [standardConsumptionPerMeter, setStandardConsumptionPerMeter] =
    useState("");

  const [dataErrors, setDataErrors] = useState({
    projectName: "",
    itemName: "",
    unit: "",
    thresholdValue: "",
    standardConsumptionPerMeter:""
  });

  const resetData = () => {
    setProjectName("");
    setItemName("");
    setThresholdValue("");
    setUnit("");
    setStandardConsumptionPerMeter("");
    setProjectId("");
    setDataErrors({
      projectName: "",
      itemName: "",
      unit: "",
      thresholdValue: "",
    standardConsumptionPerMeter:""
    });
  };

  useEffect(() => {
    if (rowData) {
      setProjectName(rowData.projectName);
      setItemName(rowData.itemName);
      setThresholdValue(rowData.thresholdValue);
      setUnit(rowData.unit);
      setStandardConsumptionPerMeter(rowData.standardConsumptionPerMeter);
      setProjectId(rowData.projectId);
    }
  }, [rowData]);
  //search
  const [search, setSearch] = useState("");

  const profileData = useSelector((state: any) => state.PROFILE);
  const { profileDetails } = profileData;
  const { data } = profileDetails;

  const validateData = () => {
    const errors: any = {};
    if (!projectName) errors.projectName = ERROR_PROJECTNAME;
    if (!itemName) errors.itemName = ERROR_ITEMNAME;
    if (!unit) errors.unit = ERROR_UNIT;
    if (!thresholdValue) errors.thresholdValue = ERROR_THRESHOLD;
    if (!standardConsumptionPerMeter) errors.standardConsumptionPerMeter = ERROR_STD_CONSUMPTION_PER_MT;

    setDataErrors(errors);
    if (Object.values(errors).length === 0) {
      return true;
    }
    Object.values(errors).map((item: any) => (!item || item === "") && true);
    return false;
  };
  const handleSubmit = () => {
    if (!validateData()) {
      return;
    }
    const totalObject = {
      projectName,
      projectId,
      itemName,
      thresholdValue,
      unit,
      standardConsumptionPerMeter,
    };
    if (rowData && rowData?._id) {
      setLoadingBtn(true);
      dispatch(
        updateThreholdValue({
          endPoint: `threshold-info/update-threshold-info/${rowData?._id}`,
          data: totalObject,
        })
      ).then(() => {
        setLoadingBtn(false);
        setRowData({})
      });
      resetData();
    } else {
      setLoadingBtn(true);
      dispatch(
        createThreholdValue({
          endPoint: "threshold-info/create-threshold-info",
          data: totalObject,
        })
      ).then(() => {
        setLoadingBtn(false)
        resetData();
      });
    }
    setTimeout(() => {
      dispatch(
        getThresholdData({
          endPoint: `threshold-info/get-all-threshold-info/`,
        })
      );
    }, 500);
  };
  const changeReset = () => {};
  useEffect(()=>{
    setRows(thresholdValues);
  },[thresholdValues])

  const filterData = (e: any) => {
    if (e.target.value !== "") {
      setSearch(e.target.value);

      const filterTable =
        thresholdValues && thresholdValues.length > 0
          ? thresholdValues.filter((item: any) =>
              item?.projectName
                ?.toLowerCase()
                ?.includes(e.target.value?.toLowerCase())||
                item?.itemName
                ?.toLowerCase()
                ?.includes(e.target.value?.toLowerCase())
            )
          : [];

      // dispatch(setThresholdHistory(filterTable));
      setRows(filterTable);
    } else {
      setRows(thresholdValues);
      setSearch("");
      dispatch(
        getThresholdData({
          endPoint: `threshold-info/get-all-threshold-info/`,
        })
      );
    }
  };
  const resetSearch = () => {
    setRows(thresholdValues);
    setSearch("");
    dispatch(
      getThresholdData({
        endPoint: `threshold-info/get-all-threshold-info/`,
      })
    );
  };
  const handleDownload = () => {
    if (thresholdValues && thresholdValues.length === 0) {
      toaster("error", "No data available");
      return;
    }
    let a: any = document.createElement("a");
    a.target = "_blank";
    a.href = `${process.env.REACT_APP_PRO_URL}/general/download?resource=INVENTORY&subResource=THRESHOLD&project=all&role=admin&user=${data._id}`;
    a.click();
  };
  return (
    <>
      {loading ? (
        <Loader
          color="#5f67e0"
          loading={loading}
          size={20}
          height="80vh"
          style={{ width: "inherit" }}
        />
      ) : (
        <Grid container className="bg--white box--shadow p1 mt1">
          <Grid item xs={12}>
            <Grid container className="d-flex v-center table_heading_box">
              <Grid container className="mt1">
                <Grid item xs={4}>
                  <Grid className="mr-1">
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb0 mt0"
                    >
                      <span className="fw500">Select Project*</span>
                    </Text>
                    <SelectBox
                      data={projectsData ? projectsData : DATA_NOT_FOUND}
                      placeHolder="Select Project"
                      defaultVal={projectName}
                      resetVal={projectName ? false : true}
                      changeReset={changeReset}
                      onChange={(e: any) => {
                        setProjectName(e.target.value);
                        const index = projectsData
                          ?.map((item: any) => item)
                          .indexOf(e.target.value);
                        setProjectId(
                          allProjectData && allProjectData[index]?._id
                        );
                        setDataErrors({ ...dataErrors, projectName: "" });
                      }}
                      borderColor={
                        dataErrors.projectName ? "danger" : "primary"
                      }
                    />
                    {dataErrors.projectName && (
                      <ErrorText text={dataErrors.projectName} />
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid className="mr-1">
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb0 mt0"
                    >
                      <span className="fw500">Select Item Name*</span>
                    </Text>
                    <SelectBox
                      data={itemTypes ? itemTypes : DATA_NOT_FOUND}
                      placeHolder="Select Item Name"
                      defaultVal={itemName}
                      resetVal={itemName ? false : true}
                      changeReset={changeReset}
                      onChange={(e: any) => {
                        setItemName(e.target.value);
                        setDataErrors({ ...dataErrors, itemName: "" });
                      }}
                      borderColor={dataErrors.itemName ? "danger" : "primary"}
                    />
                    {dataErrors.itemName && (
                      <ErrorText text={dataErrors.itemName} />
                    )}
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid className="mr-1">
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt0"
                    >
                      <span className="fw500">Item Quantity*</span>
                    </Text>
                    <Input
                      color={dataErrors.thresholdValue ? "danger" : "primary"}
                      fonts="normal"
                      placeholder="Enter Threshold Quantity"
                      name="quantity"
                      value={thresholdValue}
                      type="number"
                      min="1"
                      required
                      onChange={(e: any) => {
                        if (e.target.value.length === 6) return false;
                        if (Math.sign(parseInt(e.target.value)) === -1)
                          return false;
                        setThresholdValue(e.target.value);
                        setDataErrors({ ...dataErrors, thresholdValue: "" });
                      }}
                    />
                    {dataErrors.thresholdValue && <ErrorText text={dataErrors.thresholdValue} />}
                  </Grid>
                </Grid>
              </Grid>
              <Grid container className="mt1 mb">
                <Grid item xs={4}>
                  <Grid className="mr-1">
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb0 mt0"
                    >
                      <span className="fw500">Unit of Item*</span>
                    </Text>
                    <SelectBox
                      data={unitTypes ? unitTypes : DATA_NOT_FOUND}
                      placeHolder="Select Unit"
                      defaultVal={unit}
                      resetVal={unit ? false : true}
                      changeReset={changeReset}
                      onChange={(e: any) => {
                        setUnit(e.target.value);
                        setDataErrors({ ...dataErrors, unit: "" });
                      }}
                      borderColor={dataErrors.unit ? "danger" : "primary"}
                    />
                    {dataErrors.unit && <ErrorText text={dataErrors.unit} />}
                  </Grid>
                </Grid>
                <Grid item xs={4}>
                  <Grid className="mr-1">
                    <Text
                      type="normal"
                      fonts="normal"
                      fontSize={16}
                      className="mb mt0"
                    >
                      <span className="fw500">Std. Consumption/meter*</span>
                    </Text>
                    <Input
                      color={dataErrors.standardConsumptionPerMeter ? "danger" : "primary"}
                      fonts="normal"
                      placeholder="Enter Std. Consumption/meter"
                      value={standardConsumptionPerMeter}
                      type="number"
                      min="1"
                      required
                      onChange={(e: any) => {
                        if (e.target.value.length === 6) return false;
                        if (Math.sign(parseInt(e.target.value)) === -1)
                          return false;
                        setStandardConsumptionPerMeter(e.target.value);
                        setDataErrors({ ...dataErrors, standardConsumptionPerMeter: "" });
                      }}
                    />
                    {dataErrors.standardConsumptionPerMeter && <ErrorText text={dataErrors.standardConsumptionPerMeter} />}
                  </Grid>
                </Grid>
              </Grid>
              <Grid item xs={12} container>
                <Grid className=" mt1 mb1">
                  <Button
                    category="primary"
                    icon="delete"
                    onClick={handleSubmit}
                    type="button"
                    isRounded={true}
                    className={"submit_button"}
                  >
                    {loadingBtn ? (
                      <Loader
                        color="#fff"
                        loading={loadingBtn}
                        size={8}
                        height="auto"
                      />
                    ) : (
                      "Submit"
                    )}
                  </Button>
                </Grid>
                <Grid className=" mt1 mb1 ml-1">
                  <Button
                    category="border-only"
                    icon="delete"
                    onClick={resetData}
                    type="button"
                    className={"submit_button"}
                    isRounded={true}
                  >
                    Cancel
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}

      <Grid container className="bg--white box--shadow p1 mt1">
        <Grid item xs={12}>
          {thresholdValues?.length > 0 &&<TableHeading
            title={tableTitle.manageThresholdValues}
            placeHolder={"Search"}
            searchValue={search}
            setSearchValue={filterData}
            handleDownload={handleDownload}
            resetSearch={resetSearch}
          />}

          {thresholdValues.length > 0 ? (
            <TableComponent
              tab={null}
              heading={manageThreshold}
              data={
                thresholdValues && thresholdValues.length > 0
                  ? thresholdValues
                  : []
              }
              rows = {rows}
              setValue={setRowData}
              setDeleted={setDeleted}
            />
          ) : (
            <NoDataScreen text="No values are available for Threshold to Manage" />
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default ThresholdValues;
